package br.com.duoma.duomaproducao.viewmodel

import br.com.duoma.duomaproducao.data.spreadExecutions
import br.com.duoma.duomaproducao.model.PartExecution
import br.com.duoma.duomaproducao.model.WorkCenter
import br.com.duoma.duomaproducao.repository.getProductionReport
import br.com.duoma.duomaproducao.ui.screens.now
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.YearMonth
import kotlinx.datetime.minus
import kotlinx.datetime.yearMonth
import kotlin.collections.plusAssign
import kotlin.time.Duration.Companion.milliseconds

class ProducaoViewModel {
    val workCenters = MutableStateFlow<ExecutionInfo>(emptyMap())
    val isLoading = MutableStateFlow(false)
    val errorMessage = MutableStateFlow<String?>(null)
    var password = ""

    init {
        CoroutineScope(Dispatchers.Default).launch {
            while (password.isBlank()) {
                delay(200.milliseconds)
            }
            updateWorkcenters()
        }
    }
    fun updateWorkcenters() {
        CoroutineScope(Dispatchers.Default).launch {
            try {
                isLoading.value = true
                errorMessage.value = null
                val report = getProductionReport(password)
                    .groupBy { it.identifier() }
                    .map { (_, v) ->
                        v.first().copy(
                            executions = v.flatMap { it.executions }
                                .groupBy { "${it.workCenter} ${it.celula_producao}" }
                                .map { (_, execs) -> execs.first().copy(qt_produzida = execs.sumOf { it.qt_produzida }) }
                        )
                    }
//        println(report.filter { it.pedidoVendaId == 11655 })
                if (report.isEmpty()) {
                    isLoading.value = false
                    return@launch
                }
                val map = mutableMapOf<WorkCenter, MutableList<PartExecution>>()
                WorkCenter.entries.forEach { map[it] = mutableListOf() }
                var acc = 0
                for (prod in report) {
                    for (execution in prod.executions) {
                        if (execution.workCenter == WorkCenter.MONTAGEM && execution.dt_cadastro?.date?.yearMonth == YearMonth(
                                2026,
                                3
                            )
                        ) {
                            acc += execution.qt_produzida
                        }
                    }
                }
                println(acc)
                for (prod in report) {
                    for (wc in /*applyExecutionCascade(*/prod.executions/*)*/) {
                        val date = wc.dt_cadastro?.date ?: continue
                        map[wc.workCenter]!! += PartExecution(
                            date = date,
                            quantity = wc.qt_produzida,
                            name = prod.nomeProduto,
                            order = prod.pedidoVendaId,
                            lot = prod.loteId,
                            wc.celula_producao ?: wc.workCenter._name
                        )
                    }
                }
//        map[WorkCenter.MARCENARIA]?.add(PartExecution(LocalDate.of(2026,4,13),30,"TESTE",2345678,999))
                map[WorkCenter.MARCENARIA] = spreadExecutions(map[WorkCenter.MARCENARIA]!!).toMutableList()
                map[WorkCenter.LAMINACAO] = spreadExecutions(map[WorkCenter.LAMINACAO]!!).toMutableList()
                workCenters.value = map
            } catch (e: Throwable) {
                errorMessage.value = "Erro ao carregar dados de produção. Verifique se o computador da engenharia está ligado.\n${e.message}"
            } finally {
                isLoading.value = false
            }
        }
    }
}

typealias ExecutionInfo = Map<WorkCenter, List<PartExecution>>

fun List<PartExecution>?.quantityToday(): Int =
    this?.sumOf {
        if (it.date == LocalDate.now()) it.quantity else 0
    } ?: 0

fun List<PartExecution>?.monthAverage(): Double =
    (this?.sumOf {
        if (it.date > LocalDate.now() - DatePeriod(days = 31) && it.date < LocalDate.now()) it.quantity else 0
    } ?: 0) / 21.7
